'use client';

import React from 'react';
import { Plus, Download, RefreshCw } from 'lucide-react';
import Link from 'next/link';

export default function DashboardHeader() {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Good morning, Marcus 👋</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Thursday, August 6, 2026 · 8 active campaigns · 3 posts scheduled today
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button className="btn-ghost text-xs">
          <RefreshCw size={14} />
          <span>Refresh</span>
        </button>
        <button className="btn-ghost text-xs">
          <Download size={14} />
          <span>Export</span>
        </button>
        <Link href="/ad-campaign-management" className="btn-primary text-sm">
          <Plus size={15} />
          <span>New Campaign</span>
        </Link>
      </div>
    </div>
  );
}